import React from 'react';
import EtatPrintPage from './EtatPrintPage';

export default function EtatClientPrintPage() {
    return <EtatPrintPage mode="client" />;
}


